import axios from "axios";
import { ACTION_TYPES } from "./types";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

// Get PM2 process status
export const getPm2Status = () => async (dispatch) => {
  dispatch(setPm2Loading(true));
  dispatch(setPm2Error(null));

  try {
    const baseUrl =
      process.env.REACT_APP_SMS_API || "https://sms.api.averly.com.na";
    const endpoint = `${baseUrl}/api/v1/control/pm2/status`;

    const accessToken = Cookies.get("accessToken");

    const res = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${String(accessToken)}`,
      },
    });

    dispatch({
      type: ACTION_TYPES.GET_PM2_STATUS,
      payload: res.data,
    });

    dispatch(setPm2Loading(false));
  } catch (err) {
    console.error("Error fetching PM2 status:", err);

    const errorMessage =
      err.response?.data?.message || err.message || "Failed to fetch PM2 status";

    dispatch(setPm2Error(errorMessage));
    dispatch(setPm2Loading(false));
  }
};

// Restart PM2 process
export const restartPm2Process = (delay = 2000, processName = "sms-server") => async (dispatch) => {
  dispatch(setPm2Restarting(true));
  dispatch(setPm2Error(null));

  try {
    const baseUrl =
      process.env.REACT_APP_SMS_API || "https://sms.api.averly.com.na";
    const endpoint = `${baseUrl}/api/v1/control/pm2/restart`;

    const accessToken = Cookies.get("accessToken");

    const res = await axios.post(
      endpoint,
      {
        delay,
        name: processName,
      },
      {
        headers: {
          Authorization: `Bearer ${String(accessToken)}`,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: ACTION_TYPES.PM2_RESTART_SUCCESS,
      payload: res.data,
    });

    toast.success(
      `PM2 restart initiated successfully. Process will restart in ${delay / 1000}s`
    );

    // Wait for the delay + buffer time, then fetch new status
    setTimeout(() => {
      dispatch(setPm2Restarting(false));
      dispatch(getPm2Status());
    }, delay + 3000);

  } catch (err) {
    console.error("Error restarting PM2 process:", err);

    const errorMessage =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
      "Failed to restart PM2 process";

    dispatch(setPm2Error(errorMessage));
    dispatch(setPm2Restarting(false));

    toast.error(`Restart failed: ${errorMessage}`);
  }
};

// Set PM2 loading state
export const setPm2Loading = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_PM2_LOADING,
    payload,
  });
};

// Set PM2 error state
export const setPm2Error = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_PM2_ERROR,
    payload,
  });
};

// Set PM2 restarting state
export const setPm2Restarting = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_PM2_RESTARTING,
    payload,
  });
};

// Get PM2 logs
export const getPm2Logs = () => async (dispatch) => {
  dispatch(setPm2LogsLoading(true));

  try {
    const baseUrl =
      process.env.REACT_APP_SMS_API || "https://sms.api.averly.com.na";
    const endpoint = `${baseUrl}/api/v1/control/pm2/logs`;

    const accessToken = Cookies.get("accessToken");

    const res = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${String(accessToken)}`,
      },
    });

    dispatch({
      type: ACTION_TYPES.GET_PM2_LOGS,
      payload: res.data,
    });

    toast.success("PM2 logs fetched successfully");
    dispatch(setPm2LogsLoading(false));
  } catch (err) {
    console.error("Error fetching PM2 logs:", err);

    const errorMessage =
      err.response?.data?.message || err.message || "Failed to fetch PM2 logs";

    dispatch(setPm2Error(errorMessage));
    dispatch(setPm2LogsLoading(false));

    toast.error(`Failed to fetch logs: ${errorMessage}`);
  }
};

// Set PM2 logs loading state
export const setPm2LogsLoading = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SET_PM2_LOGS_LOADING,
    payload,
  });
};
